import { RectangleGroupIcon } from '@heroicons/react/24/outline'
import {
  containerStatusOptions,
  expedientDocumentationStatusOptions,
} from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { useContainerFilters } from './hooks/useContainerFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateStatus,
    clearAllFilters,
    hasActiveFilters,
  } = useContainerFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            searchQuery={filters.search}
            onSearchChange={updateSearch}
            placeholder="Buscar número de contenedor..."
          />

          <SelectFilter
            title="Estado"
            placeholder="Buscar estado..."
            activeSelections={filters.status}
            onSelectionsChange={updateStatus}
            selectionOptions={containerStatusOptions}
            searchActive={false}
            icon={<RectangleGroupIcon className="h-4 w-4" />}
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            activeStatuses={filters.status}
            setActiveStatuses={updateStatus}
            statusOptions={containerStatusOptions}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            handleClearFilters={handleClearFilters}
          />
        )}
      </div>
    </div>
  )
}
